import { createAction } from '@reduxjs/toolkit';

export const newGenericError = createAction('error/generic', (error, payload) => ({
  error,
  payload,
}));
